import {CSSProperties, ReactNode, useEffect, useRef, useState} from "react";
import {css, cva, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    maxLinesToShow?: number;
}

export const ShowMoreWrapperWithLineClamp = (props: IProps) => {
    const {children, preventShowLess, className, dataGtmClick, showMoreText, showLessText, maxLinesToShow} = props;

    const [shouldShowToggleButton, setVisibilityOfToggleButton] = useState(false);
    const [showContent, setShowContent] = useState<boolean>(false);

    const ref = useRef<HTMLDivElement>(null);

    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    useEffect(() => {
        const textWrapper = ref.current;

        if (textWrapper) {
            setVisibilityOfToggleButton(textWrapper.scrollHeight > textWrapper.clientHeight);
        }
    }, []);

    const linesToShow = maxLinesToShow || 4;

    return (
        <>
            <div
                ref={ref}
                className={cx(textWrapperBase, showContent && textWrapperExpanded)}
                style={
                    !showContent
                        ? ({
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: linesToShow
                          } as CSSProperties)
                        : ({
                              WebkitBoxOrient: "vertical"
                          } as CSSProperties)
                }
            >
                {children}
            </div>

            <Button
                className={cx(
                    showMoreWrapper({
                        showContent,
                        hideToggleButton: (showContent && preventShowLess) || !shouldShowToggleButton
                    }),
                    className
                )}
                variant="highlight_primary"
                onClick={() => setShowContent((prev) => !prev)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </Button>
        </>
    );
};

export const showMoreWrapper = cva({
    base: {},

    variants: {
        showContent: {
            true: {
                overflowAnchor: "none"
            },
            false: {
                overflowAnchor: "auto"
            }
        },

        hideToggleButton: {
            true: {
                visibility: "hidden"
            },
            false: {
                visibility: "visible"
            }
        }
    }
});

const textWrapperBase = css({
    display: "-webkit-box", // it is necessary for proper behaviour of -webkit-line-clamp
    overflow: "hidden"
});

const textWrapperExpanded = css({
    overflow: "initial",
    display: "block"
});
import {CSSProperties, ReactNode, useEffect, useRef, useState} from "react";
import {css, cva, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    maxLinesToShow?: number;
}

export const ShowMoreWrapperWithLineClamp = (props: IProps) => {
    const {children, preventShowLess, className, dataGtmClick, showMoreText, showLessText, maxLinesToShow} = props;

    const [shouldShowToggleButton, setVisibilityOfToggleButton] = useState(false);
    const [showContent, setShowContent] = useState<boolean>(false);

    const ref = useRef<HTMLDivElement>(null);

    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    useEffect(() => {
        const textWrapper = ref.current;

        if (textWrapper) {
            setVisibilityOfToggleButton(textWrapper.scrollHeight > textWrapper.clientHeight);
        }
    }, []);

    const linesToShow = maxLinesToShow || 4;

    return (
        <>
            <div
                ref={ref}
                className={cx(textWrapperBase, showContent && textWrapperExpanded)}
                style={
                    !showContent
                        ? ({
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: linesToShow
                          } as CSSProperties)
                        : ({
                              WebkitBoxOrient: "vertical"
                          } as CSSProperties)
                }
            >
                {children}
            </div>

            <Button
                className={cx(
                    showMoreWrapper({
                        showContent,
                        hideToggleButton: (showContent && preventShowLess) || !shouldShowToggleButton
                    }),
                    className
                )}
                variant="highlight_primary"
                onClick={() => setShowContent((prev) => !prev)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </Button>
        </>
    );
};

export const showMoreWrapper = cva({
    base: {},

    variants: {
        showContent: {
            true: {
                overflowAnchor: "none"
            },
            false: {
                overflowAnchor: "auto"
            }
        },

        hideToggleButton: {
            true: {
                visibility: "hidden"
            },
            false: {
                visibility: "visible"
            }
        }
    }
});

const textWrapperBase = css({
    display: "-webkit-box", // it is necessary for proper behaviour of -webkit-line-clamp
    overflow: "hidden"
});

const textWrapperExpanded = css({
    overflow: "initial",
    display: "block"
});
